import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { DateTimeBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

interface BackgroundCheckDateFieldProps {
    showBackgroundCheckDate: boolean;
}

export const BackgroundCheckDateField: React.FC<BackgroundCheckDateFieldProps> = ({ showBackgroundCheckDate }) => {
    const backgroundCheckDate = useBrokerDetailsStore((s) => s.backgroundCheckDate);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isMobile = isMobileScreen();

    if (!showBackgroundCheckDate) return null;

    return (
        <DateTimeBox
            id='backgroundCheckDate'
            value={backgroundCheckDate ?? undefined}
            onChange={(value: string) => updateFields({ backgroundCheckDate: value ? new Date(value) : null })}
            label='Date of Background Check'
            width={isMobile ? '100%' : '200px'}
            required={true}
        />
    );
};
